import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { getUserDetails } from '../redux/slices/AuthSlice';

export const useRefreshUserOnRouteChange = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { user } = useSelector((state) => state.auth);

    useEffect(() => {
        if (user) {
            dispatch(getUserDetails());
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, location]);

    return user;
};
